import {
  BaseFlowBlockSchema,
  FlowBlockReturnTypeSchema,
  FlowBlockType,
  FlowProducedType,
  FlowVersionTarget,
} from 'flow-schema';
import { z } from 'zod';

import { isTruthy } from '../../../../utils.js';

export const SubFlowV1BlockConfigSchema = z
  .object({
    // versionTarget and flowId are optional solely to be backwards compatible
    versionTarget: z.enum(FlowVersionTarget).optional(),
    flowId: z.string().uuid('A valid flow ID is required').optional(),

    flowDefinitionId: z.string().uuid('A valid flow definition ID is required').optional(),
    startDataBlockName: z.string().optional(),
  })
  .superRefine((obj, context) => {
    if (obj.versionTarget === undefined) {
      return; // Support legacy block definitions which didn't specify this field
    }
    if (obj.versionTarget === FlowVersionTarget.SpecificVersion) {
      if (!isTruthy(obj.flowDefinitionId)) {
        context.addIssue({
          code: 'custom',
          message: `A flow definition must be selected when using versionTarget=${obj.versionTarget}`,
          path: ['flowDefinitionId'],
        });
      }
      return;
    }
    if (obj.versionTarget === FlowVersionTarget.Published) {
      if (!isTruthy(obj.flowId)) {
        context.addIssue({
          code: 'custom',
          message: `A flow must be selected when using versionTarget=${obj.versionTarget}`,
          path: ['flowId'],
        });
      }
    }
  });

export type SubFlowV1BlockConfig = z.infer<typeof SubFlowV1BlockConfigSchema>;

export const SubFlowV1BlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(FlowBlockType.SubFlowV1),
  returnType: FlowBlockReturnTypeSchema(FlowProducedType.SubFlowV1Result),
  config: SubFlowV1BlockConfigSchema,
});

export type SubFlowV1Block = z.infer<typeof SubFlowV1BlockSchema>;
